var chunkToChildrenMap = {
	"2143": [
		532,
		7324,
		9403,
		8892,
		1931,
		9398,
		3023,
		404
	],
	"4278": [
		532,
		6672
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };